<template>
  <div>
    <v-list>
      <v-list-item>
        <CropsFrom
          ref="refCropsFrom1"
          :orderNum="1"
          :userData="userData"
          :itemsCrop="itemsCrop"
          :formHeight="formHeight"
          :corps="userData.farm === null ? '' : userData.farm.crops1"
          :prosCropsArea="userData.farm === null ? '' : userData.farm.areaSize1"
          @openSelect="openSelect(1, '주요 재배 작물 선택', itemsCrop)"
          @inputText="CropsFrom_inputText"
        />
      </v-list-item>
      <v-list-item>
        <CropsFrom
          ref="refCropsFrom2"
          :orderNum="2"
          :userData="userData"
          :itemsCrop="itemsCrop"
          :formHeight="formHeight"
          :corps="userData.farm === null ? '' : userData.farm.crops2"
          :prosCropsArea="userData.farm === null ? '' : userData.farm.areaSize2"
          @openSelect="openSelect(2, '주요 재배 작물 선택', itemsCrop)"
          @inputText="CropsFrom_inputText"
        />
      </v-list-item>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>소속단체명</v-list-item-title>
          <v-text-field
            placeholder="지역을 입력해 주세요"
            ref="refBelong"
            solo
            :height="formHeight"
            required
            v-model="userData.farm.organization"
          />
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <ProductFrom
          :orderNum="3"
          :userData="userData"
          :selectedValue="userData.farm.usedBayerProduct"
          :items="itemsProductName"
          :formHeight="formHeight"
          @openSelect="
            openSelect(3, '사용중인 바이엘 제품 선택', itemsProductName)
          "
        />
      </v-list-item>
      <v-list-item>
        <PurchaseForm
          :orderNum="4"
          :userData="userData"
          :selectedValue="
            userData.farm === null ? '' : userData.farm.purchaseArea
          "
          :items="itemsWhereToBuy"
          :formHeight="formHeight"
          @openSelect="openSelect(4, '주요 구매처 선택', itemsWhereToBuy)"
          @inputText="PurchaseForm_inputText"
        />
      </v-list-item>
    </v-list>

    <!-- 항목 선택 팝업 -->
    <SelectDialog ref="refSelectDialog" @clickOk="DialogClickOk" />
  </div>
</template>
<script>
import { mapGetters } from "vuex";
const rulesService = require("@/utils/rules.js");
const formatService = require("@/utils/format.js");
import CropsFrom from "./comp/CropsFrom.vue";
import ProductFrom from "./comp/ProductFrom.vue";
import PurchaseForm from "./comp/PurchaseForm.vue";
import SelectDialog from "@/_bayer/commonComp/dialog/SelectDialog.vue";

export default {
  components: { SelectDialog, CropsFrom, ProductFrom, PurchaseForm },
  props: {
    userData: {
      type: Object,
    },
    pageName: {
      type: String,
      default: "signup",
    },
  },
  data() {
    return {
      formHeight: 52,
      nameRules: rulesService.nameRules(),
      cellRules: rulesService.cellRules(),
      emailRules: rulesService.emailRules(),
      passwordRules: rulesService.passwordRules(),
      itemsDomain: formatService.domain(),
      itemsAge: formatService.age(),
      itemsCrop: formatService.crop25(),
      itemsProductName: formatService.productName(),
      itemsWhereToBuy: formatService.whereToBuy(),
      isDev: process.env.NODE_ENV === "development",
    };
  },
  computed: {
    passwordConfirmationRule() {
      return () =>
        this.userData.password === this.userData.rePassword ||
        "패스워드가 일치해야 합니다.";
    },
    ...mapGetters(["isAuthorized"]),
  },
  mounted() {
    if (this.isDev) {
      // this.openSelect("주요 재배 작물 선택", this.itemsCrop);
      // this.userData.name = "강감찬";
      // this.userData.cell = "01067403230";
      // this.userData.loginId = "m@predict.kr";
      // this.userData.password = "123456789!";
      // this.userData.rePassword = "123456789!";
      // this.userData.hospital = "test";
      // this.userData.majors = "피부과";
    }
  },
  methods: {
    openSelect(order, title, items) {
      console.log("openSelect");
      this.$refs.refSelectDialog.open(order, title, items);
    },
    DialogClickOk(_order, _selectedItem) {
      console.log("DialogClickOk", _order, _selectedItem.value);
      if (_order === 3) {
        this.userData.farm.usedBayerProduct = _selectedItem.value;
        return;
      }
      if (_order === 4) {
        this.userData.farm.purchaseArea = _selectedItem.value;
        return;
      }
      this.userData.farm["crops" + _order] = _selectedItem.value;
      console.log("this.userData", this.userData);
    },
    CropsFrom_inputText(e, _older) {
      this.userData.farm["areaSize" + _older] = Number(e);
      console.log("this.userData", this.userData);
    },
    PurchaseForm_inputText(e) {
      this.userData.farm.purchaseName = e;
      console.log("this.userData", this.userData);
    },
  },
};
</script>
<style lang="scss">
div.v-list:not(.v-select-list) {
  background: transparent !important;
  .v-list-item {
    padding: 0;
    .v-list-item__content {
      padding: 0;
    }
    .v-list-item__title {
      font-size: 14px;
      font-weight: bold;
      padding: 0 15px 5px;
      color: $primary-color;
      .asterisk {
        color: $text-red;
      }
    }
    &.email {
      .inner-content {
        display: flex;
        span {
          padding: 15px 6px;
          font-weight: 700;
        }
      }
    }
    .v-input {
      .v-input__slot {
        .v-btn {
          font-weight: 700;
          background-color: $mid-green;
          color: #ffffff;
          font-size: 12px;
          height: 28px;
          margin-right: -10px;
        }
      }
    }
    .v-input {
      & ~ .input-guide {
        display: block;
        font-size: 12px;
        padding: 0 10px 20px;
        margin-top: -5px;
      }
      &.error--text {
        & ~ .input-guide {
          display: none;
        }
      }
    }
  }
}
</style>